module.exports = __webpack_public_path__ + "img/double_plug_hook_box1.aa94f9b5.png";